import { render, staticRenderFns } from "./ControlPanel.vue?vue&type=template&id=038845f1"
import script from "./ControlPanel.vue?vue&type=script&lang=js"
export * from "./ControlPanel.vue?vue&type=script&lang=js"
import style0 from "./ControlPanel.vue?vue&type=style&index=0&id=038845f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubscribeLabel: require('/app/components/SubscribeLabel.vue').default,StateBadge: require('/app/components/StateBadge.vue').default,ControlPanelIndicator: require('/app/components/control-panel/ControlPanelIndicator.vue').default,ControlPanelLottie: require('/app/components/control-panel/ControlPanelLottie.vue').default,ControlPanelCircular: require('/app/components/control-panel/ControlPanelCircular.vue').default,ControlPanelLinear: require('/app/components/control-panel/ControlPanelLinear.vue').default,ControlPanelIcon: require('/app/components/control-panel/ControlPanelIcon.vue').default,ControlPanelCard: require('/app/components/control-panel/ControlPanelCard.vue').default,ControlPanelTimer: require('/app/components/control-panel/ControlPanelTimer.vue').default,ControlPanelSchedule: require('/app/components/control-panel/ControlPanelSchedule.vue').default,ClimateOnlineLabel: require('/app/components/ClimateOnlineLabel.vue').default,SubscribeBadge: require('/app/components/SubscribeBadge.vue').default})
